import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../translation/translation';

const FittingStation = (props) => {
  let {
    productSku,
    onOpenFSFClick,
    staticImagesUrl
  } = props;
    let fittingStation = `${staticImagesUrl}images/navigation/level_2/how_fitting_works.svg`;
    return (
      <div className="shipping-fees" key={productSku}>
        <div className="shipping-fees__image hidden-xs">
          <img
              alt=''
              src={fittingStation}
              width="24"
          />
        </div>
        <div className="shipping-fees__label">
          <Translation
            tagName="p"
            className="shipping-fees__learn-more product-tile__fitting-station"
            translationKey="product-tile-select-fitting-station"
            onClick={onOpenFSFClick}
          />        
        </div>
      </div>
    );
};

FittingStation.propTypes = {
  productSku: PropTypes.string.isRequired,
  staticImagesUrl: PropTypes.string.isRequired,
  onOpenFSFClick: PropTypes.func.isRequired,
};

export default FittingStation;